import { GetProductUrl, getUrlForLookbookProduct, getUrlForProductAndVariant } from '@app/logic/products';
import { isDefined, isNull } from '@app/utils/is';
import { Product } from '@typings';
import React from 'react';

interface Context {
  products: Record<string, Product.Standard>;
  isLookbook: boolean;
  getProductUrl: GetProductUrl;
}

export const usePageProductsContext = (): Context => {
  const context = React.useContext(PageProductsContext);
  if (isNull(context)) {
    throw new Error('PageProductsContext can not be used outside the scope of PageProductsContextProvider');
  }

  return context;
};

const PageProductsContext = React.createContext<Context | null>(null);

interface PageProductsContextProviderProps {
  products: Record<string, Product.Standard>;
  lookbookId?: string;
}

export const PageProductsContextProvider = ({ products, lookbookId, children }: React.WithChildren<PageProductsContextProviderProps>) => {
  const isLookbook = isDefined(lookbookId);

  return (
    <PageProductsContext.Provider
      value={{
        getProductUrl: isLookbook ? getUrlForLookbookProduct : getUrlForProductAndVariant,
        isLookbook,
        products,
      }}
    >
      {children}
    </PageProductsContext.Provider>
  );
};
